export default "__VITE_ASSET__BhsKlNr8__"